import { RouteDictionary, RouteInfo } from 'components/Models/routeTypes'

export const getRouteInfoFromPath = (path: string, routes: RouteDictionary) => {
    const pathSegments = path.match(/[^/]+/g) ?? []
    let currentRouteInfo: RouteInfo | undefined
    let currentRouteList: RouteDictionary | undefined = routes

    for (let i = 0; i < pathSegments.length; i++) {
        const segment = `/${pathSegments[i]}`
        currentRouteInfo = currentRouteList?.[segment]
        currentRouteList = currentRouteInfo?.children

        // If the route has not been fully traversed yet
        // and there are no more children in the current node,
        // that means that the path provided is invalid.
        // Return null
        if (
            i < pathSegments.length - 1 &&
            (currentRouteList === undefined || currentRouteInfo === undefined)
        ) {
            return null
        }
    }

    return currentRouteInfo
}

export const getAllRouteInfoFromPath = (
    path: string,
    routes: RouteDictionary
) => {
    const results: RouteInfo[] = []
    const pathSegments = path.match(/[^/]+/g) ?? []
    let currentRouteInfo: RouteInfo | undefined
    let currentRouteList: RouteDictionary | undefined = routes
    let segmentAccumulator = ''

    for (let i = 0; i < pathSegments.length; i++) {
        const segment = `/${pathSegments[i]}`
        segmentAccumulator += segment
        currentRouteInfo = currentRouteList?.[segment]
        currentRouteList = currentRouteInfo?.children

        if (
            i < pathSegments.length - 1 &&
            (currentRouteList === undefined || currentRouteInfo === undefined)
        ) {
            break
        } else {
            const newRouteInfo = currentRouteInfo as RouteInfo
            if (newRouteInfo) {
                newRouteInfo.path = segmentAccumulator
                results.push(newRouteInfo)
            }
        }
    }

    return results
}
